document.addEventListener("DOMContentLoaded", function () {
  // Trigger gang-image filtering on page load so only the 1st (pre-selected) colour's
  // images are shown. VariantSelects only calls validateGang()+updateGangMedia() on
  // user-initiated changes, so we fire a synthetic change here.
  document
    .querySelectorAll("variant-radios, variant-selects")
    .forEach(function (picker) {
      var checked = picker.querySelector('input[type="radio"]:checked');
      if (checked) {
        checked.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  var selectedVariant = Window.selectedVariant;
  const varIncludesCont = document.querySelector(".variant-includes span");
  var content = varIncludesCont?.innerText;
  console.log("selectedVariant", selectedVariant);
  if (content && selectedVariant) {
    changeWhatsInluded(content, selectedVariant);
  }
  if (window.innerWidth <= 768) {
    var announcementBar = document.querySelector(
      ".shopify-section-announcement-bar",
    );
    var stickyHeader = document.querySelector("sticky-header");
    if (announcementBar && stickyHeader) {
      stickyHeader.parentNode.insertBefore(announcementBar, stickyHeader);
    }
  }
  document.addEventListener("variant:change", function (value) {
    var size = value.detail.variant.option1;
    console.log("size", size);
    if (content && size) {
      changeWhatsInluded(content, size);
    }
    console.log("variant:change", value.detail);
  });
  if (Window.product) {
    modifySizeChart(
      Window.product.sizeTitle,
      Window.product.sizeColumns,
      Window.product.tags,
      Window.product.sizeSecondLastTitle,
      Window.product.sizeLastTitle,
    );
  }
});
function changeWhatsInluded(content, size) {
  var including = content.split(";").find((el) => el.includes(size));
  if (including) {
    console.log("including", including);
    setTimeout(() => {
      var cont = document.querySelector(".variant-includes");
      var contSpan = cont.querySelector("span");
      contSpan.classList.add("pre-anim");
      contSpan.innerHTML = including;
      contSpan.style.display = "inline-block";
      cont.style.display = "block";
      setTimeout(() => {
        contSpan.classList.remove("pre-anim");
      }, 800);
    }, 800);
  }
}
function modifySizeChart(
  title,
  columns,
  tags,
  sizeSecondLastTitle,
  sizeLastTitle,
) {
  var popup = document.querySelector(".product-popup-modal__content-info");
  if (title) {
    popup.querySelector("td").innerText = title;
  }
  console.log("sizeSecondLastTitle", sizeSecondLastTitle);
  var firstRow = popup.querySelector("tr td");
  firstRow.setAttribute("colspan", columns.length + 1);
  var rows = popup.querySelectorAll("tr:not(:first-child)");
  if (Window.product && Window.product.tags.includes("Duvet Cover")) {
    if (rows.length >= 3) {
      rows[2].remove();
      rows[5].remove();
      rows[6].remove();
    }
  }
  if (Window.product && Window.product.tags.includes("bamboo-sheet-set")) {
    rows[7].remove();
    rows[8].remove();
  }
  rows.forEach((row, rowInd) => {
    var tColumns = row?.querySelectorAll("td");
    tColumns.forEach((col, ind) => {
      var bold = col.querySelector("b");
      if (!bold) bold = col.querySelector("strong");
      if (!bold) bold = col.firstElementChild ?? col;
      if (ind != 0 && !columns.includes(`${ind}`)) {
        col.remove();
      }
    });
  });
}


document.addEventListener("variant:change", function (event) {
  const variant = event.detail.variant;
  if (!variant) return;
  const selectedColor = variant.option2; // adjust if needed
  document.querySelectorAll(".size-label").forEach((label) => {
    const size = label.dataset.size;
    console.log("jazbah",selectedColor, size)
    const available = productVariants.some((v) => {
      return (
        v.option2 === selectedColor &&
        v.option1 === size &&
        v.available
      );
    });
    label.classList.toggle("not_available", !available);
  });
});
